exports.default = {
  'projects': '项目',
  'search_document': '搜索页面...',
  'create_project': '新建项目',
  'new_project': '新建项目',
  'recently_visited': '最近访问',
  'no_recent_visits': '暂无最近访问记录',
  'all_projects': '全部项目',
  'no_projects_created': '您还没创建项目',
  'no_conversation_history': '暂无对话历史',
  'edit': '编辑',
  'new_page': '新建页面',
  'project_name': '项目名称',
  'project_name_placeholder': '请输入项目名称',
  'project_description': '项目描述',
  'project_description_placeholder': '请输入项目描述',
  'project_cover': '项目封面',
  'project_name_max_length': '项目名称最长为50个字',
  'cover_preview': '封面预览',
  'input_title': '请输入标题',
  'all': '全部',
  'color': '色彩',
  'document_belongs_to': '文档归属于',
  'work': '办公',
  'technology': '科技',
  'no_access_content': '创建第一个页面',
  'scenery': '风景',
  'random_cover': '随机封面',
  'random_cover_success': '已随机选择封面',
  'project_name_error': '项目名称输入不正确，无法删除',
  'upload_cover': '上传封面',
  'dark': '暗',
  'light': '亮',
  'no_conversation': '您还未与任何智能体进行会话',
  'upload_success': '封面上传成功',
  'delete_project': '删除项目',
  'development_tool': '研发工具使用',
  'delete_warning': '警告：删除当前项目及其所有页面，此操作不可恢复。',
  'confirm_by_name': '请输入项目名称以确认删除：',
  'delete_success': '删除成功',
  'name_incorrect': '项目名称输入不正确，无法删除',
  'add_failed': '新增失败',
  'edit_failed': '修改失败',
  'create_copy': '创建副本',
  'copy_name_placeholder': '请输入副本名称',
  'add_doc_placeholder': '请输入文档名称',
  'search_project': '搜索项目',
  'cancel': '取 消',
  'add_as_copy': '添加为副本',
  'unnamed_doc': '未命名',
  'add_success': '添加成功',
  'get_recent_list_failed': '获取最近访问列表失败',
  'search': '搜索',
  'catalog': '目录',
  'new_document': '新建文档',
  'new_web_page': '新建网页',
  'add_doc_to': '新建到',
  'default_move_to': '从当前项目移动到',
  'import_document': '导入文档',
  'add_group': '新建文档',
  'recently_modified': '最后修改',
  'download': '下载',
  'copy_success': '复制成功',
  'copy_failed': '复制失败，请稍后重试！',
  'operation_failed': '操作失败，请稍后重试',
  'modify_failed': '修改失败',
  'untitled_document': '未命名文档',
  'untitled_webpage': '未命名网页',
  'delete_file_title': '是否删除：{filename}',
  'delete_file_warning': '删除后将无法恢复此页面。请谨慎操作！',
  'delete_document_confirmation': '删除当前文档，请谨慎操作。',
  'delete_document': '删除文档',
  'confirm': '确定',
  'executing': '执行中...',
  'close': '关 闭',
  'cannot_move_tooltip': '不支持移动到原位置或子项下',
  'group_name_placeholder': '请输入组名称',
  'create_document': '新建文档',
  'rename': '重命名',
  'move': '移动',
  'delete': '删除',
  'sidebar_tooltip': '侧边栏',
  'prev_page_tooltip': '上一页',
  'next_page_tooltip': '下一页',
  'zoom_out_tooltip': '缩小',
  'zoom_in_tooltip': '放大',
  'download_tooltip': '下载',
  'quote': '引用',
  'rewrite': '改写',
  'rewrite_beautify': '润色美化',
  'rewrite_simple': '精简语言',
  'rewrite_expand': '扩展丰富',
  'rewrite_popular': '通俗处理',
  'explain': '解释',
  'summary': '总结',
  'translate': '翻译',
  'translate_zh_cn': '中文',
  'translate_en_us': '英语',
  'translate_ja': '日语',
  'translate_ko': '韩语',
  'translate_fr': '法语',
  'translate_de': '德语',
  'loading_image': '正在加载图片',
  'find': '查找',
  'find_in_file_placeholder': '在文件里查找',
  'analyze': '解读',
  'add_to_chat': '添加到聊天框',
  'esc_to_exit_tooltip': '可按ESC键退出',
  'rewrite_request_content': '请将【{content}】润色语言优美一些',
  'rewrite_simple_request_content': '请将【{content}】改写精简一些',
  'rewrite_expand_request_content': '请将【{content}】改写扩展丰富一些',
  'rewrite_popular_request_content': '请将【{content}】改写的通俗易懂',
  'explain_request_content': '请解释【{content}】',
  'summary_request_content': '请总结【{content}】',
  'translate_zh_request_content': '请将【{content}】翻译成中文',
  'translate_en_request_content': '请将【{content}】翻译成英语',
  'translate_ja_request_content': '请将【{content}】翻译成日语',
  'translate_ko_request_content': '请将【{content}】翻译成韩语',
  'translate_fr_request_content': '请将【{content}】翻译成法语',
  'translate_de_request_content': '请将【{content}】翻译成德语',
  'sync_success': '离线数据已同步到服务器',
  'sync_failed': '数据同步失败，已保存到本地缓存',
  'network_disconnected': '网络断开，文档已保存到本地缓存',
  'cache_restored': '缓存数据已恢复',
  'unsync_cache_detected': '检测到您有未同步的本地缓存数据，是否要恢复？',
  'abandon': '放弃',
  'restore': '恢复',
  'doc_not_exist': '文档不存在',
  'no_permission': '您没有该页面的权限',
  'page_width_setting': '页宽设置',
  'select_width': '为当前窗口选择合适页宽',
  'wide': '较宽',
  'full_wide': '全宽',
  'default': '默认',
  'find_and_replace': '查找和替换',
  'move_to': '移动到',
  'download_doc_as': '下载为',
  'project_deleted': '项目已被删除',
  'document_deleted': '文档已被删除',
  'toc': '本篇目录',
  'no_toc_found': '目录为空',
  'locating': '查找',
  'replace': '替换',
  'replace_with': '替换为',
  'search_in_doc': '在文档内查找',
  'enter_text': '请输入文字',
  'replace_all': '全部替换',
  'previous': '上一处',
  'next': '下一处',
  'confirm_delete_scope': '请确认删除范围',
  'delete_only_this_page': '仅删除此页面',
  'delete_page_with_children': '删除此页面和它包含的所有子页面',
  'exporting_wait_finish': '请先等待当前文档导出完成',
  'exporting_in_progress': '正在导出...',
  'exporting_completed': '导出完成！',
  'exporting_failed_colon': '导出失败：',
  'exporting_error_occurred_colon': '导出过程出错：',
  'export_pdf_generating': '正在生成 PDF，请稍候（最长约 2 分钟）…',
  'export_pdf_failed': 'PDF 导出失败',
  'export_pdf_no_permission': '没有权限导出该文档',
  'export_pdf_empty_doc': '文档内容为空，无法导出',
  'export_pdf_busy': '导出服务繁忙，请稍后再试',
  'export_pdf_fallback_confirm': '服务器导出失败，是否改用浏览器打印导出？',
  'export_pdf_use_browser_print': '使用浏览器打印',
  'access_scope': '项目权限',
  'access_private': '仅自己可见',
  'access_team_read': '团队只读',
  'access_team_edit': '团队可编辑'
}
